<template>
    <div>
        <div>
            <template v-if="statusId===0">
                <div class="d-md-none">
                    <a class="btn btn-secondary" href="javascript:void(0);" @click="showCancelConfirmation(appointmentId)">Cancel Appointment</a>
                </div>

                <div class="d-none d-md-block">
                    <div class="text-nowrap">
                        <a href="javascript:void(0);" @click="showCancelConfirmation(appointmentId)">Cancel Appointment</a>
                    </div>
                </div>
            </template>

            <template v-else-if="statusId===1">
                <span class="font-italic">-</span>
            </template>

            <template v-else-if="statusId===2">
                <div class="d-md-none">
                    <router-link class="btn btn-primary btn-primary-insv" :to="{'name': 'user-consultation-detail', 'params': {'id': consultationId}}">View Consultation</router-link>
                </div>

                <div class="d-none d-md-block">
                    <div class="text-nowrap">
                        <router-link :to="{'name': 'user-consultation-detail', 'params': {'id': consultationId}}">View Consultation</router-link>
                    </div>
                </div>
            </template>

            <template v-else-if="statusId===99">
                <div class="d-md-none">
                    <router-link :to="{'name': 'user-doctor-appointment-create'}" class="btn btn-primary btn-primary-insv">Schedule Another Appointment</router-link>
                </div>

                <div class="d-none d-md-block">
                    <div class="text-nowrap">
                        <router-link :to="{'name': 'user-doctor-appointment-create'}">Schedule Another Appointment</router-link>
                    </div>
                </div>
            </template>

            <template v-else-if="statusId===998">
                <div class="d-md-none">
                    <router-link :to="{'name': 'user-doctor-appointment-detail', 'params': {'id': appointmentId}}" class="btn btn-primary btn-primary-insv mb-2 mr-2">Pay Now</router-link>
                    <a href="javascript:void(0);" @click="showCancelConfirmation(appointmentId)" class="btn btn-danger mb-2">Cancel Appointment</a>
                </div>

                <div class="d-none d-md-block">
                    <div class="text-nowrap">
                        <router-link :to="{'name': 'user-doctor-appointment-detail', 'params': {'id': appointmentId}}">Pay Now</router-link> | <a href="javascript:void(0);" @click="showCancelConfirmation(appointmentId)">Cancel Appointment</a>
                    </div>
                </div>
            </template>

            <template v-else-if="statusId===999">
                <div class="d-md-none">
                    <router-link :to="{'name': 'user-doctor-appointment-create'}" class="btn btn-primary btn-primary-insv">Schedule Another Appointment</router-link>
                </div>

                <div class="d-none d-md-block">
                    <div class="text-nowrap">
                        <router-link :to="{'name': 'user-doctor-appointment-create'}">Schedule Another Appointment</router-link>
                    </div>
                </div>
            </template>

            <template v-else-if="statusId===1000 && consultationId">
                <div class="d-md-none">
                    <a href="javascript:void(0);" @click="patientStartConsultation(consultationId)" class="btn btn-primary btn-primary-insv mr-2 mb-2">Start Consultation</a>
                    <template v-if="!isConsultationStarted">
                    <a href="javascript:void(0);" @click="showCancelConfirmation(appointmentId)" class="btn btn-danger mb-2">Cancel Appointment</a>
                    </template>
                </div>

                <div class="d-none d-md-block">
                    <div class="text-nowrap">
                        <a href="javascript:void(0);" @click="patientStartConsultation(consultationId)">Start Consultation</a>
                        <template v-if="!isConsultationStarted">
                            | <a href="javascript:void(0);" @click="showCancelConfirmation(appointmentId)">Cancel Appointment</a>
                        </template>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="d-md-none">
                    <a href="javascript:void(0);" @click="showCancelConfirmation(appointmentId)" class="btn btn-danger">Cancel Appointment</a>
                </div>

                <div class="d-none d-md-block">
                    <div class="text-nowrap">
                        <a href="javascript:void(0);" @click="showCancelConfirmation(appointmentId)">Cancel Appointment</a>
                    </div>
                </div>
            </template>
        </div>

        <popup-modal ref="popupModalConfirmation" :hasCloseButton="false" title="Cancel Appointment">
            <template slot="content">
                <p>{{confirmationMessage}}</p>

                <template v-if="!isCancelling">
                    <label>Reason</label>
                    <input type="text" class="form-control" placeholder="Enter reason" v-model="cancelReason">
                </template>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-danger" @click="confirmCancelAppointment">Cancel Appointment</button>
                <button type="button" class="btn btn-secondary" @click="dismissCancelConfirmation">Cancel</button>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import popupModal from '@/components/popup-modal';
export default {
    'name': 'AppointmentActions',
    'components': {
        popupModal
    },
    'props': {
        'statusId': {
            'required': true
        },
        'appointmentId': {
            'required': true
        },
        'consultationId': {
            'type': String,
            'default': ''
        },
        'isConsultationStarted': {
            'type': Boolean,
            'default': false
        }
    },
    data () {
        return {
            'toCancelId': null,
            'confirmationMessage': '',
            'isCancelling': false,
            'cancelReason': null
        };
    },
    'methods': {
        showCancelConfirmation (toCancelId) {
            this.isCancelling = false;
            this.cancelReason = null;
            this.toCancelId = toCancelId;

            this.confirmationMessage = 'Are you sure you want to cancel this appointment? This action cannot be undone.';
            this.$refs.popupModalConfirmation.show();
        },
        confirmCancelAppointment () {
            this.isCancelling = true;
            this.confirmationMessage = 'Cancelling appointment...';

            this.axios.post('Appointment/PatientCancelAppointment', null, {
                'params': {
                    'appointmentId': this.toCancelId,
                    'cancelReason': this.cancelReason
                }
            }).then(() => {
                this.dismissCancelConfirmation().then(() => {
                    // emit appointment cancelled event
                    // then shows popup allowing user to reschedule a new one.
                    this.$emit('appointmentCancelled');
                });
            }).catch(({
                response
            }) => {

            });
        },
        dismissCancelConfirmation (callback = null) {
            this.toCancelId = null;
            return this.$refs.popupModalConfirmation.hide();
        },
        patientStartConsultation (consultationId) {
            this.axios.post('Consultation/PatientStartConsultation', null, {
                'params': {
                    'consultationId': consultationId
                }
            }).then(() => {
                this.$router.push({
                    'name': 'user-consultation-detail',
                    'params': {
                        'id': consultationId
                    }
                });
            }).catch(({
                response
            }) => {

            });
        }

    }
};
</script>

<style>

</style>
